/**
 * Some forms may require conditional recipients based on a select option.
 * This is achieved by creating multiple forms on Basin which sends to emails
 * according to the option selected. A select (snippet/form.select.liquid) will
 * require a list of formIds along with its corresponding options. If a formId
 * is specified as "default" it will take the form action specified on the
 * original form element. In the below example, selecting Option 3 will use the
 * default form action.
 *
 * Usage:
 *
 * {% assign options = "Option 1, Option 2, Option 3" %}
 * {% assign formIds = "12345, 23456, default" %}
 * {% render 'form.select',
 *  ...
 *  options options,
 *  formIds: formIds %}
 *
 * https://usebasin.com/docs/features/custom-routing
 */

custom.formActionHandler = (() => {
  const selects = document.querySelectorAll('.js-form-action-handler');

  const initSelect = (select) => {
    const options = select.dataset.options.split(', ');
    const ids = select.dataset.formIds.split(', ');
    const form = select.closest('form');
    const defaultFormAction = form.action;
    const actions = [];

    if (options.length != ids.length) {
      throw new Error(
        'Your options and IDs must be assigned with the same number of entries. Please check your usage. ',
      );
    }

    options.forEach((option, i) => {
      actions.push({
        value: option.trim(),
        id: ids[i] === 'default' ? null : ids[i],
      });
    });

    select.addEventListener('change', (e) => {
      const value = e.target.value.trim();
      const id = actions.find((action) => action.value === value).id || null;

      form.action = id
        ? `https://usebasin.com/f/${id}.json`
        : defaultFormAction;
    });
  };

  function init() {
    if (selects.length > 0) {
      selects.forEach((select) => {
        initSelect(select);
      });
    }
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/form-action-handler.js